import { render, staticRenderFns } from "./VideoUploadWithTag.vue?vue&type=template&id=792f49a7&scoped=true"
import script from "./VideoUploadWithTag.vue?vue&type=script&lang=js"
export * from "./VideoUploadWithTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792f49a7",
  null
  
)

export default component.exports